export default __webpack_public_path__ + "static/media/full.3c8aca34.jpg";